import React from "react";

import "./styles.css";

const Loading = props => {
  return <div className="loading-circle" />;
};

export default Loading;
